import { AccessStorage } from "../storage/AccessStorage";
import { Request } from "./core/olga/Request";

export class CashbackProgramAPI {
  static async request({ endpoint, data = {}, params = {}, method = "get" }) {
    return await Request.request({
      service: "environments/cashback-programs",
      endpoint: endpoint || "",
      method: method || "get",
      data: data || {},
      params: params || {},
      ignoreVersion: true,
    });
  }

  static async requestAuthenticated({
    endpoint,
    data = {},
    params = {},
    method = "get",
  }) {
    return await Request.request({
      service: "environments/cashback-programs",
      endpoint: endpoint || "",
      method: method || "get",
      headers: {
        Authorization: `Bearer ${AccessStorage.getAccessToken()}`,
      },
      data: data || {},
      params: params || {},
      ignoreVersion: true,
    });
  }

  static async getProgram(id = null, brandId) {
    return await CashbackProgramAPI.requestAuthenticated({
      endpoint: id ? `/${id}` : "",
      params: {
        brandId
      }
    });
  }

  static async getProgramReports(id) {
    return CashbackProgramAPI.requestAuthenticated({
      endpoint: `/${id}/reports`,
      method: "get",
    });
  }

  static async getProgramHistory(brandId, page, limit) {
    return CashbackProgramAPI.requestAuthenticated({
      endpoint: "/history",
      params: { brandId },
    });
  }

  static async putProgram(programData) {
    return CashbackProgramAPI.requestAuthenticated({
      method: "put",
      data: programData,
    });
  }

  static async putStatus(id, status) {
    return CashbackProgramAPI.requestAuthenticated({
      endpoint: `/${id}/status/${status}`,
      method: "put",
    });
  }
}
